import React from'react';import ImageDemo from'../../../../src/demo/components/ImageDemo.tsx';import{jsx as _jsx}from"react/jsx-runtime";function process(image,IJS){image=image.grey();return image.derivativeFilter();}const name='/opt/buildhome/repo/docs/Features/Filters/demos/derivative.demo.tsx';const code=`import { Image } from 'image-js';

export default function derivativeFilter(image: Image) {
  image = image.grey();
  return image.derivativeFilter();
}
`;const defaultEditorCode=`import * as IJS from 'image-js';
/**
 * Process the image
 * @param { IJS.Image } image the input image
 * @returns { IJS.Image | IJS.Mask } the processed image or mask
 */
export function process(image) {
  image = image.grey();
  return image.derivativeFilter();
}
  `;export default function Demo(props){return/*#__PURE__*/_jsx(ImageDemo,{code:code,defaultEditorCode:defaultEditorCode,processImage:process,name:name,isMask:false,...props});}